// Original hypothetical scenarios; order rules and available order types vary by market and broker.
export const executionReview = {
  moduleId: 'execution',
  title: '從委託成交到股數變動，核對真正發生的事',
  questions: [
    {
      id: 'execution-market-order-depth',
      lessonId: 'market-limit-orders',
      question: '某假想股票最後成交價為 48 元，目前賣方掛出 30 股、每股 50 元，以及 70 股、每股 50.4 元。你以市價買進 80 股。假設依賣價由低到高成交、委託簿保持不變、沒有其他訂單競爭且忽略費用，平均成交價是多少？',
      options: [
        '50.25 元：先買 30 股，再由下一檔買 50 股',
        '48 元：市價單保證使用畫面上的最後成交價',
        '50 元：所有股數都能使用最低賣價成交',
      ],
      answer: 0,
      explanation: '依題設，成本為 30×50＋50×50.4＝4,020 元，平均為 4,020÷80＝50.25 元。最後成交價是已發生交易的價格，最低賣價也只有題目列出的數量。實際交易時報價、深度和可成交數量可能改變，不能把這次靜態演算當成市價單的價格保證。',
    },
    {
      id: 'execution-stop-gap-trigger',
      lessonId: 'stop-orders',
      question: '某假想平台的賣出 stop-market 委託跨夜有效，停損觸發價為 60 元，規則明定成交價到達或低於 60 元即轉成市價賣單。隔日首筆成交為 52 元，觸發後可成交的買價為 51.5 元，且數量足夠、價格不再改變。忽略費用，哪個理解正確？',
      options: [
        '設定 60 元，便保證整筆賣在 60 元',
        '價格跳過 60 元，所以一定要等反彈至 60 元才會觸發',
        '首筆 52 元已觸發；依題設以 51.5 元成交，60 元只是觸發條件',
      ],
      answer: 2,
      explanation: '題目使用的是觸發後轉為市價單的 stop-market，並明定以成交價判斷，因此跳空至 52 元仍滿足觸發條件。轉單後依可成交價格執行，停損價不是成交價下限。若是 stop-limit，觸發後另有價格限制，也可能完全未成交；實際支援的類型、觸發依據及有效時段須看平台規則。',
    },
    {
      id: 'execution-split-value-neutral',
      lessonId: 'stock-splits',
      question: '你持有某假想公司 80 股，每股參考價 75 元。公司將每 2 股舊股拆成 5 股新股。只計算拆股比例的理論調整，沒有其他價格變動、費用或零股處理問題，調整後應如何理解？',
      options: [
        '仍持有 80 股、每股 30 元，持股總值降為 2,400 元',
        '持有 200 股、每股 30 元，持股總值仍為 6,000 元',
        '持有 200 股、每股仍為 75 元，持股總值直接增至 15,000 元',
      ],
      answer: 1,
      explanation: '股數乘以 5÷2，得到 200 股；每股理論參考價乘以 2÷5，得到 30 元。兩者相乘仍為 6,000 元。全公司按相同比例拆股時，你的持有比例也不因拆股本身改變；股數變多不等於憑空多出財富，後續市場成交價仍可因其他因素波動。',
    },
    {
      id: 'execution-buyback-eps-and-cash',
      lessonId: 'share-buybacks',
      question: '某假想公司全年歸屬普通股股東的淨利為 900 萬元，原有流通普通股 300 萬股。公司在年初用 600 萬元現金，以每股 20 元買回並註銷股份，之後全年股數不變。假設淨利不受回購影響，沒有利息、稅費或其他股份變動，哪個敘述正確？',
      options: [
        '回購後基本 EPS 約為 3.33 元，同時現金減少 600 萬元，不能只憑 EPS 上升判定創造價值',
        '淨利沒有改變，所以基本 EPS 必定仍為 3 元',
        '基本 EPS 升至約 3.33 元，代表公司因此額外賺到 600 萬元現金',
      ],
      answer: 0,
      explanation: '買回股數為 600 萬÷20＝30 萬股；年初註銷後，全年加權平均流通股數為 270 萬股。因此基本 EPS 從 900÷300＝3 元，變為 900÷270≈3.33 元。分母變小不代表淨利增加，回購還使用了 600 萬元現金。判斷影響仍須考慮回購價格、資金用途與實際獲利變化；若在年中回購，EPS 分母也要按流通時間加權。',
    },
  ],
};
